let env = 'prod';

export const config = {
    frontEndBaseUrl:
        env === 'prod'
            ? 'https://app.click4driver.com/'
            : 'http://localhost:3000/',

    backEndBaseUrl:
        env === 'prod'
            ? 'https://app.click4driver.com/api/'
            : 'http://localhost:3050/api/',

    placeHolderImage: 'https://community.softr.io/uploads/db9110/original/2X/7/74e6e7e382d0ff5d7773ca9a87e6f6f8817a68a6.jpeg',
    
    mapApiKey: env === 'prod'
        ? process.env.REACT_APP_GOOGLE_MAPS_KEY
        : process.env.REACT_APP_GOOGLE_MAPS_KEY,

};
